import { Client, Coach } from "@/types/page";
import Storage from "@/utils/Storage";

type SavedMessageUserType = Client["type"] | Coach["type"];

export const scopedStorageKey = (
    userType: SavedMessageUserType,
    clientId: Client["id"],
    coachId: Coach["id"],
    suffix: string,
) => `${userType}_${clientId}_${coachId}_${suffix}`;

const savedMessageKey = (
    userType: SavedMessageUserType,
    clientId: Client["id"],
    coachId: Coach["id"],
) => scopedStorageKey(userType, clientId, coachId, "savedMessage");

export function setSavedMessage(
    userType: SavedMessageUserType,
    clientId: Client["id"],
    coachId: Coach["id"],
    message: string,
) {
    Storage.save(savedMessageKey(userType, clientId, coachId), message);
}

export function getSavedMessage(
    userType: SavedMessageUserType,
    clientId: Client["id"],
    coachId: Coach["id"],
) {
    return Storage.load(savedMessageKey(userType, clientId, coachId), "");
}

export function clearSavedMessage(
    userType: SavedMessageUserType,
    clientId: Client["id"],
    coachId: Coach["id"],
) {
    Storage.save(savedMessageKey(userType, clientId, coachId), "");
}
